<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size lg_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('TITLE.POPUP.SELECT.AREA.OF.ANSWER') }}</i>
                    </dt>
                    <dd>
                        <!--Subsidiary-->
                        <div class="Select_wrap">
                            <ul class="txt_sel">
                                <li class="tit">Subsidiary</li>
                                <li data-input-type="text" class="w84">
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C4L1" />
                                            <i class="check-icon"> </i>
                                        </label>
                                        <em>SEAD</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C4L0" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SEAG</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C4M6" />
                                            <i class="check-icon"> </i>
                                        </label>
                                        <em>SEB</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C4B1" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SEBN</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C493" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SECZ</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C480" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SEF</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C460" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SEG</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C4N2" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SEGR</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C490" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SEH</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C4A0" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SEI</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C4F0" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SENA</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C4E0" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SEP</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C4D0" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SEPOL</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C4B6" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SEROM</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C470" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SESA</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C4L2" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SESG</em>
                                    </div>
                                    <div class="check_wrap">
                                        <label class="checkbox-wrap mr5">
                                            <input type="checkbox" name="subsidiaryCd" value="C430" />
                                            <i class="check-icon"></i>
                                        </label>
                                        <em>SEUK</em>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <!--//Subsidiary-->

                        <!--Product Category-->
                        <div class="sub_tit w100 mt20">{{ $t('FIELD.GLOBAL.PRODUCT.CATEGORY') }}</div>
                        <div class="selmultiple_wrap">
                            <dl class="doubleset">
                                <dd>
                                    <select
                                        class="slt_white"
                                        v-model="category1Code"
                                        @change="categoryList(2)"
                                        :disabled="categoryDisabled"
                                    >
                                        <option value="">{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                        <option
                                            v-for="item in category1CodeList"
                                            :key="pageName + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </dd>
                                <dt>
                                    <select
                                        v-model="category2Code"
                                        @change="categoryList(3)"
                                        multiple=""
                                        :disabled="categoryDisabled"
                                    >
                                        <option value="" v-if="0 === category2CodeList.length">
                                            {{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}
                                        </option>
                                        <option
                                            v-for="item in category2CodeList"
                                            :key="pageName + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                    <select v-model="category3Code" multiple="" :disabled="categoryDisabled">
                                        <option value="" v-if="0 === category3CodeList.length">
                                            {{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}
                                        </option>
                                        <option
                                            v-for="item in category3CodeList"
                                            :key="pageName + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </dt>
                            </dl>
                            <dd class="btn">
                                <span>
                                    <a href="javascript:" class="ico_arrow_next box" @click="next('category')"></a>
                                    <a href="javascript:" class="ico_arrow_prev box" @click="prev('category')"></a>
                                </span>
                            </dd>
                            <div class="addsel">
                                <select multiple="" :disabled="categoryDisabled" v-model="unSelectedPrdOption">
                                    <option
                                        v-for="item in selectedPrdOption"
                                        :value="item.viewCode"
                                        :key="item.viewCode + item.viewName"
                                    >
                                        {{ item.viewName }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!--Inquiry Type-->
                        <div class="sub_tit w100 mt20">{{ $t('FIELD.GLOBAL.INQUIRY.TYPE') }}</div>
                        <div class="selmultiple_wrap">
                            <dl class="doubleset">
                                <dd>
                                    <select class="slt_white " v-model="inquiry1Code" @change="inquiryList(2)">
                                        <option value="">
                                            {{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}
                                        </option>
                                        <option
                                            v-for="item in inquiry1CodeList"
                                            :key="pageName + item.CD"
                                            :value="item.CD"
                                        >
                                            {{ item.CD_NAME }}
                                        </option>
                                    </select>
                                </dd>
                                <dt>
                                    <select class="w100" v-model="inquiry2Code" multiple="">
                                        <option value="" v-if="0 === inquiry2CodeList.length">
                                            {{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}
                                        </option>
                                        <option
                                            v-for="item in inquiry2CodeList"
                                            :key="pageName + item.CD"
                                            :value="item.CD"
                                        >
                                            {{ item.CD_NAME }}
                                        </option>
                                    </select>
                                </dt>
                            </dl>
                            <dd class="btn">
                                <span>
                                    <a href="javascript:" class="ico_arrow_next box" @click="next('inquiry')"></a>
                                    <a href="javascript:" class="ico_arrow_prev box" @click="prev('inquiry')"></a>
                                </span>
                            </dd>
                            <div class="addsel">
                                <select multiple="" v-model="unSelectedInqOption">
                                    <option
                                        v-for="item in selectedInqOption"
                                        :value="item.viewCode"
                                        :key="item.viewCode + item.viewName"
                                    >
                                        {{ item.viewName }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!--User-->
                        <div class="sub_tit w100 mt20">{{ $t('FIELD.GLOBAL.USER') }}</div>
                        <div class="srchModal_wrap select_set2 user_srch">
                            <dl class="dl_search">
                                <dd data-input-type="select">
                                    <select class="slt_white w100p" v-model="searchKey">
                                        <option value="name">{{ $t('FIELD.USER.NAME') }}</option>
                                        <option value="id">{{ $t('FIELD.USER.ID') }}</option>
                                    </select>
                                </dd>
                                <dd data-input-type="input" class="clearable">
                                    <input type="text" class="text_input w100p" v-model="searchName" v-clearable />
                                </dd>
                                <dd class="btn">
                                    <a href="javascript:" class="btn_srch" @click="onSearch()">
                                        {{ $t('FIELD.GLOBAL.SEARCH') }}
                                    </a>
                                </dd>
                            </dl>
                        </div>
                        <div class="selmultiple_wrap">
                            <div class="grid_wrap mt-10">
                                <toast-grid
                                    :gridId="gridId"
                                    :columns="columns"
                                    :data="gridData"
                                    :options="options"
                                    :ref="gridId"
                                    :key="gridKey"
                                />
                            </div>
                            <dd class="btn">
                                <span>
                                    <a href="javascript:" class="ico_arrow_next box" @click="next('user')"></a>
                                    <a href="javascript:" class="ico_arrow_prev box" @click="prev('user')"></a>
                                </span>
                            </dd>
                            <div class="addsel mt10">
                                <select multiple="" v-model="unSelectedAnswerer">
                                    <option
                                        v-for="item in selectedAnswerer"
                                        :value="item.viewCode"
                                        :key="item.viewCode + item.viewName"
                                    >
                                        {{ item.viewName }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_modal_wrap topLine">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_white" @click="$emit('close')">
                                    {{ $t('BUTTON.GLOBAL.CANCEL') }}
                                </a>
                                <a href="javascript:" class="btn_blue" @click="onSave()">
                                    {{ $t('BUTTON.GLOBAL.SAVE') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import ToastGrid from '~c/ToastGrid';

export default {
    name: 'europeAddPop',
    components: {
        'toast-grid': ToastGrid,
    },
    props: {
        searchRhqCode: '',
        searchSubsidiary: '',
        searchCategoryA: '',
        searchInquiryType1: '',
        targetUser: '',
        targetUserNm: '',
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            pageName: 'europeAddPop',
            pageTitle: '',
            categoryDisabled: false,
            inquiry2Code: [],
            category1Code: '',
            category2Code: [],
            category3Code: [],
            inquiry1Code: '',
            inquiry1CodeList: [],
            inquiry2CodeList: [],
            category1CodeList: [],
            category2CodeList: [],
            category3CodeList: [],
            unSelectedAnswerer: [],
            unSelectedInqOption: [],
            unSelectedPrdOption: [],
            selectedAnswerer: [],
            selectedInqOption: [],
            selectedPrdOption: [],
            rhqCode: '',
            subsidiary: '',
            loginId: '',
            loginNo: '',
            loginNm: '',
            searchKey: 'name',
            searchName: '',
            gridKey: 0,
            gridId: 'europeAddPopGrid',
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.LOGIN.ID'),
                    name: 'ID',
                    align: 'center',
                    width: 150,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.USER.NAME'),
                    name: 'NAME',
                    align: 'center',
                    width: 200,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.ADMIN.PART.NAME'),
                    name: 'DEPT_NM',
                    align: 'center',
                    // width: 200,
                    resizable: true,
                    sortable: false,
                },
            ],
            gridData: [],
            options: {
                scrollX: false,
                scrollY: true,
                header: { height: 45 },
                rowHeight: 45,
                bodyHeight: 200,
                rowHeaders: ['checkbox'],
            },
        };
    },
    mounted() {
        this.rhqCode = this.searchRhqCode;
        this.subsidiary = this.searchSubsidiary;
        this.category1Code = this.searchCategoryA;
        this.inquiry1Code = this.searchInquiryType1;

        this.categoryList(1);
        this.inquiryList(1);
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            curLoginNo: 'getLoginNo',
            roles: 'getRoles',
        }),
    },
    watch: {
        inquiry1Code() {
            if (['PQ4', 'PQ8'].includes(this.inquiry1Code)) {
                this.categoryDisabled = true;
                this.category1Code = '';
                this.category2CodeList = [];
                this.category3CodeList = [];
                this.selectedPrdOption = [];
                this.selectedPrdOption.push({
                    viewCode: 'Z|99|9919',
                    viewName: 'Other Products > Other Products > Others',
                });
            } else {
                this.categoryDisabled = false;
            }
        },
    },
    methods: {
        async inquiryList(v) {
            let type = 'inquiryType' + v;
            if (v === 4) {
                type = 'gbm_cd';
            }
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: type,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.corpCd,
                        value: this.inquiry1Code,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1Code = '';
                        this.inquiry2Code = [];
                        this.inquiry1CodeList = resp.data.result.rowData;
                        this.inquiryList(2);
                    } else if (v === 2) {
                        this.inquiry2Code = [];
                        this.inquiry2CodeList = resp.data.result.rowData;
                    }
                });
        },
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1Code = '';
                this.category2Code = [];
                this.category3Code = [];
                this.category1CodeList = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.getUserCorpCd).then(resp => {
                    this.category1CodeList = resp;
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2Code = [];
                this.category3Code = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.getUserCorpCd).then(resp => {
                    this.category2CodeList = resp;
                });
            } else if (v === 3) {
                codeCategoryId = 'ADM_CATEGORY_C';
                // parentCode = this.category2Code;
                this.category3Code = [];
                this.category3CodeList = [];

                for (let code of this.category2Code) {
                    parentCode = code;
                    await this.getCodeComboList(parentCode, codeCategoryId, this.getUserCorpCd).then(resp => {
                        for (const category of resp) {
                            this.category3CodeList.push(category);
                        }
                    });
                }
            }
        },
        async getCodeComboList(categoryVal, categoryCode, addCondition) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, addCondition);
            return codeResp;
        },
        async onSearch() {
            let searchUserName = '';
            let searchUserId = '';
            if ('name' === this.searchKey) {
                searchUserName = this.searchName;
            } else {
                searchUserId = this.searchName;
            }
            let url = `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/answererManage/addPopupEUSubsidiarySearch.skp`;

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    url,
                    qs.stringify({
                        filterId: searchUserName,
                        filterName: searchUserId,
                    }),
                )
                .then(resp => {
                    this.gridData = resp.data.result.rowData;
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onSave() {
            if (!['PQ4', 'PQ8'].includes(this.inquiry1Code) && 0 === this.selectedPrdOption.length) {
                alert(SDLUtil.getMsgProp('BUTTON.GLOBAL.ADD') + ' ' + SDLUtil.getMsgProp('FIELD.GLOBAL.PRODUCT'));
                return;
            } else if (0 === this.selectedInqOption.length) {
                alert(SDLUtil.getMsgProp('BUTTON.GLOBAL.ADD') + ' ' + SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY'));
                return;
            } else if (0 === this.selectedAnswerer.length) {
                alert(SDLUtil.getMsgProp('BUTTON.GLOBAL.ADD') + ' ' + SDLUtil.getMsgProp('FIELD.GLOBAL.ANSWERERS'));
                return;
            }

            let user = [];
            for (const code of this.selectedAnswerer) {
                user.push(code.viewCode);
            }
            let inquiry = [];
            for (const code of this.selectedInqOption) {
                inquiry.push(code.viewCode);
            }
            let category = [];
            for (const code of this.selectedPrdOption) {
                category.push(code.viewCode);
            }

            let subsidiaryCd = [];
            $('input[name=subsidiaryCd]').each(function(idx) {
                if ($(this).is(':checked')) {
                    subsidiaryCd.push($(this).val());
                }
            });

            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.SAVE.CONFIRM'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/answererManage/newAddGbmSaveEU.skp`,
                            qs.stringify({
                                deptLevelCd: 2,
                                selectedAnswerer: user,
                                selectedPrdOption: category,
                                selectedInqOption: inquiry,
                                subsidiaryCd: subsidiaryCd,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            let msg = resp.data.msg;
                            SDLUtil.alert(msg);

                            if (msg.indexOf('successfully') > -1) {
                                this.rtnFunc();
                                this.$emit('close');
                            }
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        next(v) {
            let viewName = '';
            let viewCode = '';

            if ('category' === v) {
                for (let code of this.category3Code) {
                    for (const category3 of this.category3CodeList) {
                        if (category3.code === code) {
                            viewCode = category3.code;
                            viewName = category3.codeName;
                            for (const category2 of this.category2CodeList) {
                                if (category2.code === category3.parentCode) {
                                    viewCode = category2.code + '|' + viewCode;
                                    viewName = category2.codeName + ' > ' + viewName;
                                    for (const category1 of this.category1CodeList) {
                                        if (category1.code === category2.parentCode) {
                                            viewCode = category1.code + '|' + viewCode;
                                            viewName = category1.codeName + ' > ' + viewName;
                                            this.selectedPrdOption.push({ viewCode: viewCode, viewName: viewName });
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else if ('inquiry' === v) {
                for (let code of this.inquiry2Code) {
                    for (const inquiry2 of this.inquiry2CodeList) {
                        if (inquiry2.CD === code) {
                            viewCode = inquiry2.CD;
                            viewName = inquiry2.CD_NAME;
                            for (const inquiry1 of this.inquiry1CodeList) {
                                if (inquiry1.CD === inquiry2.P_CD) {
                                    viewCode = inquiry1.CD + '|' + viewCode;
                                    viewName = inquiry1.CD_NAME + ' > ' + viewName;
                                    this.selectedInqOption.push({ viewCode: viewCode, viewName: viewName });
                                }
                            }
                        }
                    }
                }
            } else if ('user' === v) {
                let grid = this.$refs['europeAddPopGrid'].$refs['europeAddPopGrid'];
                let getData = grid.invoke('getData');
                for (const data of getData) {
                    if (data._attributes.checked) {
                        this.selectedAnswerer.push({ viewCode: data.LOGIN_NO, viewName: data.NAME });
                    }
                }
            }
        },
        prev(v) {
            if ('category' === v) {
                for (let code of this.unSelectedPrdOption) {
                    const idx = this.selectedPrdOption.findIndex(function(item) {
                        return item.viewCode === code;
                    });
                    if (idx > -1) this.selectedPrdOption.splice(idx, 1);
                }
            } else if ('inquiry' === v) {
                for (let code of this.unSelectedInqOption) {
                    const idx = this.selectedInqOption.findIndex(function(item) {
                        return item.viewCode === code;
                    });
                    if (idx > -1) this.selectedInqOption.splice(idx, 1);
                }
            } else if ('user' === v) {
                for (let code of this.unSelectedAnswerer) {
                    const idx = this.selectedAnswerer.findIndex(function(item) {
                        return item.viewCode === code;
                    });
                    if (idx > -1) this.selectedAnswerer.splice(idx, 1);
                }
            }
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/qnaManager/popup/europeAddPop.vue